import { ArrowForward } from '@mui/icons-material'
import { Button, ButtonProps } from '@mui/material'
import React from 'react'
import { Term } from 'types'

export type TermWebsiteLinkProps = ButtonProps<
  'a',
  {
    term?: Term | null
  }
>

const TermWebsiteLink = ({ term, ...props }: TermWebsiteLinkProps) => {
  return !term || !term.website ? (
    <></>
  ) : (
    <Button href={term.website} target="_blank" endIcon={<ArrowForward />} {...props}>
      {term.websiteLabel || 'Visit Website'}
    </Button>
  )
}

export default TermWebsiteLink
